/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { NgModule } from '@angular/core';
import { ItemsComponent } from './components/items.component';
import { ItemsRoutingModule } from './items-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ItemsListComponent } from './components/itemslist.component';
import { ItemsFilterComponent } from './components/itemsfilter.component';
import { ItemsService } from './services/items.service';
import { DataTablesModule } from 'angular-datatables';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ItemDetailComponent } from './components/itemdetail.component';
import { ItemDetailContainerComponent } from './components/itemdetailcontainer.component';
import { ItemRelatedRequestsComponent } from './components/itemrelatedrequests.component';
import { ItemDetailService } from './services/itemdetail.service';
import { ItemRelatedRequestsService } from './services/itemrelatedrequests.service';
import { SpinnerModule } from '../../../shared/spinner/spinner.module';
import { InfiniteScrollModule } from '../shared/module/infinite-scroll.module';
import { ReportIncidentModule } from '../newrequest/reportincident/reportincident.module';

@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        ItemsRoutingModule,
        ReactiveFormsModule,
        ReactiveFormsModule,
        DataTablesModule,
        SpinnerModule,
        InfiniteScrollModule,
        ReportIncidentModule

    ],
    declarations: [ItemsComponent, ItemsListComponent, ItemsFilterComponent,
        ItemDetailContainerComponent, ItemDetailComponent, ItemRelatedRequestsComponent],
    providers: [ItemsService , ItemDetailService , ItemRelatedRequestsService ],
    exports: [ItemsComponent]
})
export class ItemsModule { }
